import { Plus } from "lucide-react";

import { Button } from "@src/shared/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@src/shared/components/ui/popover";
import { useActor } from "@src/shared/providers/actorProvider";

import { BulkImportPanel } from "./BulkImportPanel";
import { useBulkDocumentJobs } from "./useBulkDocumentJobs";

export const BulkDocumentUpload = () => {
  const actor = useActor();
  const userId = String(actor.user.id);

  const { jobs, addJobs, markJobFailed, removeJob } =
    useBulkDocumentJobs(userId);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="w-full lg-stitch:w-auto"
        >
          <Plus />
          Import Documents
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[min(calc(100vw-2rem),420px)]">
        <BulkImportPanel
          jobs={jobs}
          onJobsAdded={addJobs}
          onJobFailed={markJobFailed}
          onJobRemove={removeJob}
        />
      </PopoverContent>
    </Popover>
  );
};
